export default __webpack_public_path__ + "static/media/whatsappImage.e6231d5f.svg";